<template>
  <div class="login_container">
    <LoginVerificationInner v-if="defaultPage"></LoginVerificationInner>
    <LoginVerificationInnerBv v-if="is8V"></LoginVerificationInnerBv>
    <!-- <RegisterInner v-if="is8V && darkMode == 1"></RegisterInner> -->
  </div>
</template>
<script>
import { VUE_UNION_STATION } from "@/assets/js/stationSetting";
import { mapActions, mapGetters } from "vuex";
import LoginVerificationInnerBv from "@/pages/login/loginVerification-inner-bv.vue";
import LoginVerificationInner from "@/pages/login/loginVerification-inner.vue";
export default {
  mixins: [],

  data() {
    return {
      is8V: false,
      defaultPage: false,
    };
  },
  components: { LoginVerificationInner, LoginVerificationInnerBv },
  computed: {
    // ...mapGetters({
    //   darkMode: "user/darkMode"
    // })
  },
  created() {
    // this.defaultPage = true;
    if (VUE_UNION_STATION == "8V") {
      this.is8V = true;
    } else {
      this.defaultPage = true;
    }
  },
  beforeDestroy() {},
  destroyed() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss"></style>
